/**
 * Get the shared mail parameters from the URL
 */
const getSharedMailParamsFromUrl = () => {
  const pathname = window.location.pathname;

  const paramList = _parseKeyValuePairs(pathname);

  return {
    key: paramList?.j || "",
    collectionId: paramList?.c || "",
    userId: paramList?.u || "",
    encryptedRequestUserEmail: paramList?.r || "",
    encryptedRequestSenderEmail: paramList?.sm || "",
    encryptedDeletedLinkRequest: paramList?.delete || "",
    encryptedContributorEmail: paramList?.con || "",
  };
};

const _parseKeyValuePairs = (input: string): Record<string, string> => {
  const result: Record<string, string> = {};
  let jValue = "";
  let cValue = "";
  let uValue = "";
  let rValue = "";
  let smValue = "";
  let deleteValue = "";
  let conValue = "";

  // Split the input string into segments by "/"
  const segments = input.split("/").filter((segment) => !!segment);

  // Find the index of "j" parameter
  const jIndex = segments.findIndex((segment) => segment === "j");

  // If "j" is not found, return empty result
  if (jIndex === -1) {
    return result;
  }

  // Get segments starting from "j"
  const relevantSegments = segments.slice(jIndex);

  // Process segments after "j"
  for (let i = 0; i < relevantSegments.length - 1; i += 2) {
    const paramType = relevantSegments[i];
    const paramValue =
      i + 1 < relevantSegments.length ? relevantSegments[i + 1] : "";

    switch (paramType) {
      case "j":
        jValue = paramValue;
        break;
      case "c":
        cValue = paramValue;
        break;
      case "u":
        uValue = paramValue;
        break;
      case "r":
        rValue = paramValue;
        break;
      case "sm":
        smValue = paramValue;
        break;
      case "delete":
        deleteValue = paramValue;
        break;
      case "con":
        conValue = paramValue;
        break;
      default:
        console.log(`Unknown parameter type: ${paramType}`);
    }
  }

  // Map the values to the result object
  result.j = jValue;
  result.c = cValue;
  result.u = uValue;
  result.r = rValue;
  result.sm = smValue;
  result.delete = deleteValue;
  result.con = conValue;

  return result;
};

export default getSharedMailParamsFromUrl;
